export const styles = {
  baseContainer: {
    marginTop: 2,
    padding: 2,
    paddingTop: "1px"
  },
  dataTitle: {
    fontWeight: 500,
    whiteSpace: 'pre-wrap'
  }
}
